import { UsersService } from '@/services/users.service'

export default {
  getCurrent({ commit }) {
    return UsersService.getCurrent()
      .then((user) => {
        commit('SET_CURRENT_USER', user.data)
        commit('DEFINE_USER_ABILITIES')
      })
      .catch((error) =>
        commit('toast/NEW', { type: 'error', message: error.message }, { root: true })
      )
  },
}
